import React, { useEffect } from 'react';

import { useCardReader } from 'Src/feature/card-reader/useCardReader';

/**
 * CardReaderConnect
 * @description - used to bring up a prompt when card reader has not been connected to the browser ( navigator.hid )
 */
const CardReaderConnect: React.FC = () => {
  const cardReader = useCardReader();
  useEffect(() => {
    void cardReader.connect();
    // "cardReader.connect"
    //  - is stable (internal parts use refs)
    //  - very important that this only runs when first mounting
    //  - connection is async and we should limit the calls to this
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
};

export { CardReaderConnect };
